/* artmie-variant-picker-sort.js — v2.1 (2026-09-11)
   Shows size / dimension variant cards in ascending order WITHOUT moving DOM nodes, and WITHOUT breaking the
   theme's "in stock first, then sold out" grouping (snippets/custom-pdp-variant-picker.liquid renders available
   values first, unavailable values second).
   v1 moved the <label> nodes: the theme's variant-picker morphs the picker back to the server order after every
   selection and v1 re-sorted on the next DOM mutation, so the cards swapped places once or twice per click
   ("the cards jump, I cannot choose"). v1 also sorted sold-out sizes in between in-stock ones, and compared
   numbers without units ("1 l" before "300 ml").
   v2.1 writes CSS `order` rules into one <style>, keyed by the option value id (stable, rendered by the server,
   kept by morph, still there when the mobile slider moves the labels out of the fieldset). Rank = availability
   group (in stock first) → promo badge first → size ascending (unit-aware) → server order. Recomputed after every
   variant update (availability of a value can change with the selection). Hiding beyond 8 values stays with
   component-custom-pdp-variant-picker.js. Browsers without :has() simply keep the server order. */
(function () {
  "use strict";
  if (!/^\/products\//.test(location.pathname)) return;
  var STYLE_ID = "artmie-picker-order";
  var VOL = { ml: 1, "мл": 1, cl: 10, dl: 100, l: 1000, "л": 1000 };
  var MASS = { g: 1, "г": 1, kg: 1000, "кг": 1000 };
  var LEN = { mm: 1, "мм": 1, cm: 10, "см": 10, m: 1000, "м": 1000, inch: 25.4, "in": 25.4, "\"": 25.4, "'": 304.8 };
  var UNIT = "(ml|мл|cl|dl|l|л|g|г|kg|кг|mm|мм|cm|см|m|м|inch|in|\"|'|oz|fl\\s*oz)";
  var RE_DIM = new RegExp("^(\\d+(?:\\.\\d+)?)\\s*x\\s*(\\d+(?:\\.\\d+)?)\\s*" + UNIT + "?\\s*$", "i");
  var RE_ONE = new RegExp("^(\\d+(?:\\.\\d+)?)\\s*" + UNIT + "\\s*$", "i");
  function parseKey(v, idx) {
    if (!v) return [9, idx];
    var s = String(v).toLowerCase().replace(/×/g, "x").replace(/х/g, "x").replace(/,/g, ".").trim(), m;
    m = s.match(RE_DIM);
    if (m) { var f = (m[3] && LEN[m[3]] != null) ? LEN[m[3]] : 10; return [0, parseFloat(m[1]) * f, parseFloat(m[2]) * f]; } /* dimensions; no unit = cm */
    m = s.match(RE_ONE);
    if (m) {
      var n = parseFloat(m[1]), u = m[2].replace(/\s+/g, " ");
      if (VOL[u] != null) return [1, n * VOL[u]];
      if (MASS[u] != null) return [2, n * MASS[u]];
      if (LEN[u] != null) return [3, n * LEN[u]];
      return [4, n]; /* oz / fl oz */
    }
    m = s.match(/^(\d+(?:\.\d+)?)$/);
    if (m) return [5, parseFloat(m[1])];
    return [9, idx];
  }
  function compareKeys(a, b) {
    if (a[0] !== b[0]) return a[0] - b[0];
    for (var i = 1; i < Math.max(a.length, b.length); i++) { var av = a[i] !== void 0 ? a[i] : 0, bv = b[i] !== void 0 ? b[i] : 0; if (av !== bv) return av - bv; }
    return 0;
  }
  function attr(s) { return String(s).replace(/["\\]/g, "\\$&"); }
  /* One picker → rules for all its fieldsets (all or none, so groups never interleave in the mobile slider). */
  function rulesFor(picker) {
    var fieldsets = picker.querySelectorAll("fieldset[data-fieldset-index]"), groups = [], needed = false;
    for (var f = 0; f < fieldsets.length; f++) {
      var fs = fieldsets[f], fi = parseInt(fs.getAttribute("data-fieldset-index"), 10) || 0;
      /* the mobile slider moves the labels out of the fieldset: find them by their inputs' fieldset index instead */
      var inputs = document.querySelectorAll('label.custom-pdp-variant-picker__value input[data-option-value-id][data-fieldset-index="' + attr(fi) + '"]');
      if (inputs.length < 2) continue;
      var keyed = [], anyParsed = false;
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i], lbl = inp.closest("label"), k = parseKey(inp.value, i);
        if (k[0] < 9) anyParsed = true;
        keyed.push({ id: inp.getAttribute("data-option-value-id"), key: k, avail: inp.getAttribute("data-option-available") === "false" ? 1 : 0, promo: /\d{1,3}\s*%/.test(lbl ? lbl.textContent || "" : "") ? 0 : 1, idx: i });
      }
      if (!anyParsed) continue;
      keyed.sort(function (a, b) { return a.avail - b.avail || a.promo - b.promo || compareKeys(a.key, b.key) || a.idx - b.idx; });
      for (var j = 0; j < keyed.length; j++) if (keyed[j].idx !== j) { needed = true; break; }
      groups.push({ fi: fi, keyed: keyed });
    }
    if (!needed) return [];
    var rules = [];
    for (var g = 0; g < groups.length; g++) for (var r = 0; r < groups[g].keyed.length; r++)
      rules.push('label.custom-pdp-variant-picker__value:has(input[data-option-value-id="' + attr(groups[g].keyed[r].id) + '"]){order:' + (groups[g].fi * 1000 + r) + "}");
    return rules;
  }
  function computeRules() {
    var rules = [], pickers = document.querySelectorAll("variant-picker");
    for (var p = 0; p < pickers.length; p++) rules = rules.concat(rulesFor(pickers[p]));
    return rules.join("\n");
  }
  function apply() {
    var css = computeRules(), el = document.getElementById(STYLE_ID);
    if (!el) { if (!css) return; el = document.createElement("style"); el.id = STYLE_ID; document.head.appendChild(el); }
    if (el.textContent !== css) el.textContent = css;
    document.documentElement.setAttribute("data-artmie-picker-order", css ? "css" : "server");
  }
  var debounce = 0;
  function schedule() { clearTimeout(debounce); debounce = setTimeout(apply, 80); }
  var observer = new MutationObserver(schedule);
  function start() {
    apply();
    try { observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-product-id", "data-option-available"] }); } catch (_) {}
    document.addEventListener("variant:update", schedule);
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", start, { once: true }) : start();
})();
